import React from 'react';
import ProjectItem from './ProjectItem';
import SectionHeader from './SectionHeader';

const projectsData = [
  {
    id: 0,
    title: 'Location History Heatmap',
    description:
      'A Python script that transforms Google Location History data into an interactive, private heatmap visualization. Features time-based filtering and animation to explore location patterns across different periods directly in your browser.',
    imageUrl: '/project5.png',
    projectUrl: 'https://github.com/mgsrevolver/timeline_google-maps/tree/main',
    technologies: ['Python', 'Leaflet.js', 'JSON'],
  },
  {
    id: 1,
    title: 'Earnings Echo',
    description:
      'An AI-powered earnings report analyzer that helps retail investors identify macro trends and sentiment patterns across 40+ companies. Uses Claude AI to extract insights from SEC filings including guidance tone, capex trends, and partnership announcements. Free and open-source.',
    imageUrl: '/projectearnings.png',
    projectUrl: 'https://earningsecho.io/',
    technologies: ['Next.js', 'TypeScript', 'Tailwind', 'Claude AI'],
  },
  {
    id: 2,
    title: 'Overlay',
    description:
      'A live sports commentary platform that lets fans choose their preferred commentators. Features include audio broadcasting, a soundboard, listener chat, and game clock / ESPN API synchronization. Currently focused on NBA and NFL games.',
    imageUrl: '/project1.jpg',
    projectUrl: 'https://overlayaudio.com/',
    technologies: ['React', 'Tailwind', 'Supabase', 'Cursor AI'],
  },
  {
    id: 4,
    title: 'ConsoleSpy for Cursor',
    description:
      'An MCP server (and browser extension) that sends console logs directly to an AI IDE like Claude or Cursor. Removes a lot of annoying copying and pasting.',
    imageUrl: '/project4.png',
    projectUrl: 'https://github.com/mgsrevolver/consolespy',
    technologies: ['MCP', 'Extensions', 'Dev Tools'],
  },
  {
    id: 5,
    title: 'Kelly Criterion Calculator',
    description:
      'A simple calculator that helps sports bettors determine the optimal bet size based on their edge and bankroll. My first web development project, built in 2021.',
    imageUrl: '/project2.jpg',
    projectUrl: 'https://mgsrevolver.github.io/kellycalc/',
    technologies: ['JavaScript', 'Vue.js', 'React'],
  },
  {
    id: 6,
    title: 'Photography',
    description:
      'A new hobby I just picked up in 2025! I mostly shoot urban landscapes and architecture and edit in Lightroom.',
    imageUrl: '/project3.jpg',
    projectUrl: 'https://adobe.ly/3EQF8s4',
    technologies: ['Sony a6700', 'Sigma 18-50mm', 'Lightroom'],
  },
];

// ... existing code ...

const Projects = () => {
  return (
    <section
      id="projects"
      className="content-section pt-4 pb-2 sticky-section"
      aria-label="Selected projects"
    >
      <SectionHeader id="projects" title="Side Projects" />

      <div>
        <ul className="group/list">
          {projectsData.map((project) => (
            <ProjectItem key={project.id} project={project} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Projects;
